<template>
  <v-card flat>
    <v-card flat>
      <v-text-field
        label="Type your search here..."
        solo
        flat
        clearable
        v-model="query"
        @clear="reset()"
      ></v-text-field>
    </v-card>

    <!--<p class="text-right">Search result amount : ({{ searchResult.pagination.total }})</p>
    <p class="text-right">Search performed in {{ searchResult.timings.search }} ms, facets in {{ searchResult.timings.facets }} ms</p>-->

    <span v-if="searchResult.data.aggregations">
      <v-divider></v-divider>

      <v-card flat pa-2>
        <span v-for="facet in searchResult.data.aggregations" :key="facet.name">
          <span v-for="bucket in filters[facet.name]" :key="bucket.key">
            <v-chip
              close
              @input="unselectBucket(facet.name,bucket)"
              color="primary"
            >{{ bucket | trim(36) }}</v-chip>
          </span>
        </span>
      </v-card>
    </span>

    <v-card flat pa-2>
      <v-list dense>
        <v-list-group v-for="facet2 in searchResult.data.aggregations" :key="facet2.name">
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>{{ getFacetLabel(facet2) }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile v-for="bucket in facet2.buckets" :key="bucket.key">
            <v-list-tile-action>
              <v-checkbox v-model="filters[facet2.name]" :value="bucket.key"></v-checkbox>
            </v-list-tile-action>

            <v-list-tile-content
              style="white-space: nowrap;"
              :title="getBucketLabel(bucket)"
            >{{getBucketLabel(bucket)}}</v-list-tile-content>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-card>
    <v-divider></v-divider>
  </v-card>
</template>
<style>
</style>
<script>
import { mapGetters } from "vuex";
import { api } from "@/store/modules/users";

import itemsjs from "itemsjs";
import _ from "lodash";

import FormattingMixin from "@/components/mixins/FormattingMixin.vue";

export default {
  // TODO: NTH -> Facets nur anzeigen, wenn es mehr als ein Bucket gibt
  props: {
    rows: Array,
    configuration: Object,
    perPage: {
      type: Number,
      default: 100
    },
    page: {
      type: Number,
      default: 1
    }
  },
  created() {
    const defaultFilter = this.configuration.filter;

    this.itemsJsInstance = itemsjs(this.rows, this.configuration);
    this.query = this.$route.query.query || "";

    if (this.$route.query.filter) {
      this.filters = JSON.parse(this.$route.query.filter) || {};
    } else {
      const filters = {};
      Object.keys(this.configuration.aggregations).map(v => {
        if (defaultFilter && v in defaultFilter) {
          filters[v] = defaultFilter[v];
        } else {
          filters[v] = [];
        }
      });
      this.filters = filters;
    }
  },
  watch: {
    // TODO: Ist das der beste Weg?
    rows: function() {
      this.itemsJsInstance = itemsjs(this.rows, this.configuration);
    },
    $route: function() {
      this.query = this.$route.query.query || "";

      if ("filter" in this.$route.query) {
        this.filters = JSON.parse(this.$route.query.filter) || {};
      } else {
        const filters = {};
        Object.keys(this.configuration.aggregations).map(v => {
          filters[v] = [];
        });
        this.filters = filters;
      }
    }
  },
  data() {
    /*var filters = {};
    Object.keys(this.configuration.aggregations).map(function(v) {
      filters[v] = [];
    });*/
    return {
      query: "",
      filters: {},
      itemsJsInstance: {},
      urlquery: "Dumm wie stroh"
    };
  },
  methods: {
    getFacetLabel(facet) {
      return facet.title + " (" + facet.buckets.length + ")";
    },
    unselectBucket(facetName, tagBucket) {
      this.filters[facetName] = this.filters[facetName].filter(
        item => item !== tagBucket
      );
    },
    getBucketLabel(bucket) {
      return bucket.key + " (" + bucket.doc_count + ")";
    },
    reset() {
      var filters = {};
      Object.keys(this.optionList.aggregations).map(function(v) {
        filters[v] = [];
      });
      this.filters = filters;
      this.query = "";
    },
    // TODO: Das Verhalten muss noch besprochen werden!
    triggerRouter: _.debounce(function(query) {
      this.$router.push({ query: query });
    }, 500)
  },
  computed: {
    ...mapGetters(api.namespace, [api.getters.getUser]),
    currentRows() {
      return null;
    },
    searchResult() {
      let result = this.itemsJsInstance.search({
        per_page: this.rows.length,
        page: 1,
        query: this.query,
        filters: this.filters
      });

      this.$emit(
        "itemsjs-result-list-changed",
        result.data.items,
        this.filters,
        this.query
      );
      if (this.query != "" || this.filters != "") {
        console.log("Filter act", this.query, this.filters);

        const currentFilter = JSON.stringify(this.filters);

        const query = { query: this.query, filter: currentFilter };
        this.triggerRouter(query);
      }

      return result;
    }
  },
  mixins: [FormattingMixin]
};
</script>
